<template>
  <div class="bnr" :style="{backgroundImage: `url(${image})`}"></div>
</template>

<script>
  import { mapState } from 'vuex'
  import { get } from 'lodash'

  export default {
    data () {
      return {
        showDetails: false,
        minHeightContent: 0
      }
    },
    computed: {
      ...mapState('tours', ['agent']),
      image () {
        return get(this.agent.banner, '[0].urls[1].url')
      }
    }
  }
</script>

<style lang="scss">
  .bnr {
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }
</style>
